import { FC } from 'react';
import { Form, Table } from 'antd';
import { useForm } from '@/libs/antd/form';
import { FileSearchOutlined } from '@ant-design/icons';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import FleetTitle from '@/libs/antd/components/Title';
import { SiteReportPhoto } from '@/libs/fleet-api/services/types';
import { useFBDHVisitReportApprovalPage } from './VisitReportApproval';
import { getDocumentType } from '@/components/modals/PreviewModal';
import { useModals } from '@/components/modals/ModalProvider';

type SiteVisitReportPhoto = SiteReportPhoto<'payload'> &
	Pick<SiteReportPhoto, 'photo'>;

type SiteVisitReportPhotoForm = {
	lists: SiteVisitReportPhoto[];
};

const FBDHSiteVisitReportPhoto: FC = () => {
	const { openDocumentModal } = useModals();
	const { siteReport } = useFBDHVisitReportApprovalPage();
	const { form, fieldName } = useForm<SiteVisitReportPhotoForm>();

	return (
		<Form.Provider>
			<FleetTitle>Foto Survey Site</FleetTitle>
			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				form={form}
				initialValues={
					{
						lists:
							siteReport?.photos?.map((photo) => {
								return {
									id: photo.id,
									description: photo.description,
									photo: {
										id: photo.photo.id,
										name: photo.photo.name,
										path: photo.photo.path,
										url: photo.photo.url,
									},
								};
							}) ?? [],
					} as SiteVisitReportPhotoForm
				}
				style={{ marginBottom: 30 }}
			>
				<Form.Item
					name={fieldName(['lists'])}
					noStyle
				/>
				<Form.Item shouldUpdate>
					{({ getFieldsValue }) => {
						const values = getFieldsValue() as SiteVisitReportPhotoForm;
						const dataSource =
							values?.lists?.map((list, key?) => {
								return { ...list, key };
							}) ?? [];

						return (
							<Table
								bordered
								pagination={false}
								dataSource={dataSource}
								columns={[
									{
										title: 'View Photo',
										render: (_, { photo }) => {
											return (
												<a
													href="#"
													onClick={(e) => {
														e.preventDefault();
														if (!photo) return;
														openDocumentModal([
															{
																name: photo.name,
																type: getDocumentType(photo.name)!,
																url: photo.url,
															},
														]);
													}}
												>
													<FileSearchOutlined />
												</a>
											);
										},
										width: 110,
										align: 'center',
									},
									{
										title: 'Description',
										render: (_, record) => record.description ?? '-',
									},
								]}
							/>
						);
					}}
				</Form.Item>
			</Form>
		</Form.Provider>
	);
};

export default FBDHSiteVisitReportPhoto;
